// BaseKit (JS version)

import { Extension } from '@tiptap/core'
import { Document } from '@tiptap/extension-document'
import { HardBreak } from '@tiptap/extension-hard-break'
import { ListItem } from '@tiptap/extension-list'
import { Paragraph } from '@tiptap/extension-paragraph'
import { Text } from '@tiptap/extension-text'
import { TextStyle } from '@tiptap/extension-text-style'
import { CharacterCount, Dropcursor, Focus, Gapcursor, Placeholder } from '@tiptap/extensions'
import { createMentionExtension } from '@/tiptap/extensions/mentions'

// Adjust these import paths to match your project
// NODE_TYPE_MENU comes from your constants/define.js (we created earlier)
import { NODE_TYPE_MENU } from '@/tiptap/constants/define.js'
// defaultBubbleList / generateBubbleTypeMenu should be exported from your bubble helper
// e.g. src/tiptap/extensions/components/bubble.js
import { defaultBubbleList, generateBubbleTypeMenu } from './components/bubble.js'

export const BaseKit = /* @__PURE__ */ Extension.create({
  name: 'base-kit',

  addOptions() {
    return {
      ...(this.parent?.() || {}),
      bubble: {
        list: NODE_TYPE_MENU,
        defaultBubbleList,
        button: ({ editor, extension, t }) => {
          const { list = {}, defaultBubbleList } = extension.options?.bubble ?? {}
          const defaultList = (typeof defaultBubbleList === 'function' ? defaultBubbleList(editor) : []) || []
          return generateBubbleTypeMenu(list, defaultList, { editor, extension, t })
        },
      },
    }
  },

  addExtensions() {
    const extensions = []

    if (this.options.placeholder !== false) {
      extensions.push(
        Placeholder.configure({
          placeholder: '',
          ...(this.options.placeholder || {}),
        }),
      )
    }

    if (this.options.focus !== false) {
      extensions.push(
        Focus.configure({
          className: 'focus',
          ...(this.options.focus || {}),
        }),
      )
    }

    if (this.options.document !== false) {
      extensions.push(Document.configure())
    }

    if (this.options.text !== false) {
      extensions.push(Text.configure())
    }

    if (this.options.gapcursor !== false) {
      extensions.push(Gapcursor.configure())
    }

    if (this.options.dropcursor !== false) {
      extensions.push(Dropcursor.configure(this.options.dropcursor || {}))
    }

    if (this.options.characterCount !== false) {
      extensions.push(CharacterCount.configure(this.options.characterCount || {}))
    }

    if (this.options.paragraph !== false) {
      extensions.push(Paragraph.configure(this.options.paragraph || {}))
    }

    if (this.options.hardBreak !== false) {
      extensions.push(HardBreak.configure(this.options.hardBreak || {}))
    }

    if (this.options.listItem !== false) {
      extensions.push(ListItem.configure(this.options.listItem || {}))
    }

    if (this.options.textStyle !== false) {
      extensions.push(TextStyle.configure(this.options.textStyle || {}))
    }

    // Include handbook mentions in all TipTap instances that use BaseKit (viewer + diff)
    try {
      extensions.push(
        createMentionExtension({
          char: '#',
          className: 'mention-handbook',
          apiPath: '/api/handbook-sections/suggestions/',
          hrefBuilder: (item) => `/handbook/article/${item.id}`,
          mapItem: (raw) => ({ id: raw.id, label: raw.title }),
        }),
      )
    } catch (_) {
      // no-op if extension factory is unavailable
    }

    return extensions
  },
})

export default BaseKit